import { useTranslation } from 'react-i18next'

import { Financial } from './Financial'
import { Schedule } from './Schedule'

import { LittleText, SubTitle, Text } from '@/components/common/UI'
import { Card, CardHeader, CardBody } from '@/components/nextui'
import { useStore } from '@/store'

function getDayAndMonth(dateStr: string, t: (key: string) => string) {
    // Soporta formatos:
    // - 'YYYY-MM-DD'
    // - 'DD/MM/YYYY'
    // - Cualquier formato válido para new Date() (por ejemplo ISO: '2025-09-29T00:00:00')

    let day: number | null = null
    let monthIndex: number | null = null

    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        // '2025-09-29'
        const parts = dateStr.split('-')

        monthIndex = Number(parts[1])
        day = Number(parts[2])
    } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
        // '29/09/2025'
        const parts = dateStr.split('/')

        day = Number(parts[0])
        monthIndex = Number(parts[1])
    } else {
        // Fallback: intentar parsear con new Date (ej: ISO del backend)
        const parsed = new Date(dateStr)

        if (isNaN(parsed.getTime())) {
            return { day: 0, month: '' }
        }

        day = parsed.getDate()
        monthIndex = parsed.getMonth() + 1 // getMonth() es 0-11
    }

    // Si por alguna razón no se pudo calcular correctamente
    if (!day || !monthIndex) {
        return { day: 0, month: '' }
    }

    // Mes en texto desde traducción (months.1 = ENE, months.2 = FEB, etc.)
    const monthName = t(`months.${monthIndex}`)

    return {
        day,
        month: monthName
    }
}

export const Footer = (): JSX.Element => {
    const { t } = useTranslation()
    const startDate = useStore((state) => state.startDate)

    console.log('startDate en footer:', startDate)

    return (
        <Card
            id="footer-section"
            className="mt-8 mb-2 md:mb-0"
        >
            <CardHeader>
                <SubTitle
                    className="pl-4 border-l-5 border-primary"
                    subTitle={t('information')}
                />
            </CardHeader>
            <CardBody className="grid gap-6 lg:grid-cols-2">
                <Card className="w-full">
                    <Financial />
                </Card>
                <Card className="w-full">
                    <CardHeader className="flex justify-center">
                        <Text
                            text={t('footer.calendar')}
                            className="font-bold text-center uppercase w-full"
                        />
                    </CardHeader>
                    <CardBody>
                        <LittleText
                            text="✅ Si perteneces a un grupo cerrado o a una cohorte especial, ten en cuenta que las fechas establecidas pueden diferir de las fechas generales."
                            className="text-center w-full"
                        />
                        <div className="grid grid-cols-1 gap-4">
                            {startDate && (
                                <Schedule
                                    key={999}
                                    contentBody={
                                        '¡Tu periodo académico inicia!'
                                    }
                                    date={getDayAndMonth(startDate, t)}
                                    id={999}
                                />
                            )}
                        </div>
                    </CardBody>
                </Card>
            </CardBody>
        </Card>
    )
}
